"use client";

import "@/components/bloks/defineBloks";
import { GoogleTagManager } from "@next/third-parties/google";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { CentraProvider } from "@trydig/centra/client";
import { ReviewsIoProvider } from "@trydig/reviews-io";
import { StoryblokProvider } from "@trydig/storyblok";
import { NextUIProvider } from "@trydig/ui/next";
import { Provider } from "jotai";
import { useRouter } from "next/navigation";
import { type PropsWithChildren, useState } from "react";
import { env } from "@/env.mjs";
import { REVIEWS_STORE_ID } from "@/features/reviews/constants";

export const Providers = ({ children }: PropsWithChildren) => {
	const router = useRouter();
	const [queryClient] = useState(() => new QueryClient());

	const handlePublish = () => {
		router.refresh();
	};

	return (
		<NextUIProvider>
			<QueryClientProvider client={queryClient}>
				<StoryblokProvider onPublished={handlePublish}>
					<CentraProvider apiUrl={env.NEXT_PUBLIC_CENTRA_CHECKOUT}>
						<Provider>
							<ReviewsIoProvider storeId={REVIEWS_STORE_ID}>
								{children}
							</ReviewsIoProvider>
						</Provider>
						<ReactQueryDevtools />
						<GoogleTagManager gtmId={env.NEXT_PUBLIC_GTM_ID} />
					</CentraProvider>
				</StoryblokProvider>
			</QueryClientProvider>
		</NextUIProvider>
	);
};
